// extracted by mini-css-extract-plugin
module.exports = {"demoBox":"demo-module--demo-box--2IBC4"};